import { render, staticRenderFns } from "./ConfirmRestore.vue?vue&type=template&id=329291b3&scoped=true"
import script from "./ConfirmRestore.vue?vue&type=script&lang=js"
export * from "./ConfirmRestore.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRestore.vue?vue&type=style&index=0&id=329291b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329291b3",
  null
  
)

export default component.exports